<script>
import {Money} from 'v-money';

import {currencySymbol} from "../../../mixins/currency";

export default {
    name: "OrderBulkActionForm",

    props: {
        selectedIds: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    components: {
        Money
    },
    mixins: [currencySymbol],
    data() {

        return {
            orderCount: 0,
            actionType: 'markProcessed',
            refundType: 'full',
            amount: 0,
            money: {
                decimal: '.',
                thousands: ',',
                prefix: this.convertCurrencyCodeToPrefix(this.currency),
                suffix: '',
                precision: 2,
                masked: true
            },
        }
    },
    mounted() {
        window.addEventListener('order_count', (e) => {
            this.orderCount = e.detail.count;
        })
    },
    methods:{
        clear(){
            return this.$emit('clear');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Orders/Form/BulkAction.vue